<template>
  <node-view-wrapper
    class="generic-file-wrapper"
    :class="{
      '!w-full': mt(InlineMediaType.Video),
      'w-[260px]': props?.node?.attrs?.mediaType === InlineMediaType.File,
    }"
    :data-block-id="props?.node?.attrs?.['block-id']"
  >
    <SpecificMedia
      :type="props.node.attrs.mediaType"
      :editor="props.editor"
    />
  </node-view-wrapper>
</template>

<script setup lang="ts">
import { NodeViewWrapper } from '@tiptap/vue-3';
import type { Node as ProseMirrorNode } from '@tiptap/pm/model';
import { computed, provide } from 'vue';
import SpecificMedia from './specificMedia/SpecificMedia.vue';
import { Editor } from '@tiptap/core';
import { InlineMediaType } from '@superthread-com/extension-inline-media/src/index';

/**
 * The correct type definition would be:
 * const props = defineProps<typeof nodeViewProps>();
 *
 * However, that is not supported in Vue 2, so the type must be
 * specified like this.
 */
const props = defineProps<{
  node: ProseMirrorNode;
  deleteNode: (() => () => void) | undefined;
  editor: Editor;
  updateAttributes: CallableFunction;
}>();

provide(
  'node',
  computed(() => props.node)
);
provide('deleteNode', props.deleteNode);
provide('editor', props.editor);
provide('updateAttributes', props.updateAttributes);

function mt(mediaType: InlineMediaType) {
  return props.node.attrs.mediaType === mediaType;
}
</script>

<style lang="scss">
.generic-file-wrapper {
  margin-top: 0.5rem;
}
.page-editor-wrap {
  .generic-file-wrapper {
    width: 100% !important;
    max-width: 700px;
    margin: 0.5rem auto;

    &.ProseMirror-selectednode {
      &::before {
        width: fit-content !important;
      }
      & > *::before {
        content: '';
        height: 100%;
        width: 100%;
        position: absolute;
        background: rgba(38, 125, 206, 0.7098039216);
        top: 0;
        z-index: 1;
        pointer-events: none;
        border-radius: 8px;
        left: 0;
      }
    }
  }
}
</style>
